<template>
    <div>
        <b-loading  :active.sync="isFullScreenLoading" ></b-loading>
        <nav class="panel" v-if="user_fn">
            <div class="panel-heading">
                <nav class="level is-mobile">
                    <div class="level-left">
                        <div class="level-item">
                            <i class="has-text-info" >{{user_fn}} </i>
                        </div>
                        <div class="level-item">
                            <i class="has-text-link" >{{status_name}} </i>
                        </div>
                    </div>
                </nav>
            </div>

            <div class="panel-heading">
                <nav class="level is-mobile">
                    <div class="level-left">
                        <div class="level-item" >
                            <b-button
                                    label="Clear checked"
                                    type="is-danger"
                                    icon-left="close"
                                    class="field"
                                    :disabled="!checkedRows.length>0"
                                    @click="checkedRows = []"
                            />
                        </div>
                    </div>
                    <div class="level-right">
                        <div class="level-item box">
                            <b-button
                                    icon-left="bookmark-check-outline"
                                    type="is-info"
                                    :disabled="!checkedRows.length>0"
                                    @click="saveToCompleteStatus"
                            >

                                <span>to  Complete  <b-tag rounded    type="is-danger is-light"> {{checkedRows.length}} </b-tag> </span>
                            </b-button>
                        </div>
                        <div class="level-item box">
                            <b-field position="is-centered"
                                     :type="{ 'is-danger':   hasErrorReasonNull  }"
                                     :message= "{ 'blank data, please select reason' :   hasErrorReasonNull  }">
                                <b-button
                                        icon-left="delete"
                                        type="is-warning"
                                        :disabled="!checkedRows.length>0"
                                        @click="saveToDisable"
                                >
                                    <span>to Disable <b-tag rounded    type="is-info"> {{checkedRows.length}} </b-tag> </span>
                                </b-button>

                                <b-select placeholder="Select a reason" :disabled="!checkedRows.length>0" v-model="id_disable_lab">
                                    <option
                                            v-for="data in listofdisablereason"
                                            :value="data.id"
                                            :key="data.id">
                                        {{ data.name }}
                                    </option>
                                </b-select>
                            </b-field>
                        </div>
                    </div>
                </nav>
            </div>




            <div class="panel-block">

                        <b-table
                                :data="isEmpty ? [] : data_Selected.data "
                                bordered
                                striped
                                narrowed
                                hoverable
                                focusable
                                mobile-cards
                                checkable
                                :checked-rows.sync="checkedRows"

                        >
                            <b-table-column  label="Lab No."  v-slot="props">
                                <span :class="isIDLabSelected(props.row.idlab) ? 'tag is-success is-large' : '' "   >
                                   {{ props.row.idlab }}
                                </span>

                            </b-table-column>


                            <b-table-column  label="OPD No."  v-slot="props">
                                {{ props.row.idopd }}
                            </b-table-column>

                            <b-table-column  label="Pet Name"  v-slot="props">
                                {{ props.row.opd_name }}
                            </b-table-column>

                            <b-table-column  label="Owner Name"  v-slot="props">
                                {{ props.row.owner_name }}
                            </b-table-column>


                        </b-table>

            </div>
        </nav>
    </div>
</template>

<script>




    import {mapState} from "vuex";
    import axios from "axios";
    import { getBaseURLforBackEnd , getConfigAxios }  from '@/utils.js'


    export default {
        name: "DetailEachDashboardLabNonStatus",
        mounted() {
            // console.log('mount DetailEachDashboardLabNonStatus')
        },
        props:{
            user_fn : String,
            user_id : Number,
            status_id : Number,
            status_name : String,
            data_Selected: Object  // { "status_id": 2, "status_name": "Assiged",
                                   //       "data": [ { "idlab": "63Cyto0000000003", "idopd": "52039575", "opd_name": "ทดสอบ1", "owner_name": "ทดสอบ ทดสอบ", "species": "CROSSBREED", "breed": "สุนัข" }, ... ]
        },
        computed:{
            ...mapState({
                listofdisablereason: state => state.master_data.listofdisablereason,
                access_token: state => state.master_data.access_token,
            })
        },
        data(){
            return{
                isEmpty : false,
                checkedRows:[],
                id_disable_lab : null,
                hasErrorReasonNull : false,
                isFullScreenLoading : false
            }
        },
        methods:{
             saveToCompleteStatusReal(){

                 const vm = this

                 const tmpIdlabs = this.checkedRows.map(dat=>{
                     return dat.idlab
                 })


                 const datTo = {
                     "idlab" : tmpIdlabs
                     // "user_id" : this.user_id
                 }

                 this.isFullScreenLoading = true
                 axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                 axios.post(`${getBaseURLforBackEnd()}/api/make_tocomplete_status_labnon`,datTo,getConfigAxios())
                     .then((res)=>{
                         vm.$buefy.toast.open({
                             duration: 2000,
                             message: `${res.data.msg}`,
                             position: 'is-bottom',
                             type: 'is-success'
                         })
                         vm.isFullScreenLoading = false
                         vm.$emit('saveChanged')
                     })
                     .catch((err)=>{
                         vm.$buefy.toast.open({
                             duration: 2000,
                             message: `${err.message}`,
                             position: 'is-bottom',
                             type: 'is-danger'
                         })
                         vm.isFullScreenLoading = false
                     })





             },
             saveToCompleteStatus(){
                 this.$buefy.dialog.confirm({
                     title: 'Change Status To Complete Lab',
                     message: 'Are you sure you want to <b>disable</b>? This action cannot be undone.',
                     confirmText: 'Change Status To Complete Lab',
                     type: 'is-danger',
                     hasIcon: true,
                     onConfirm: () => this.saveToCompleteStatusReal()
                 })
             },
             saveToDisableReal(){

                 const vm = this

                 const tmpIdlabs = this.checkedRows.map(dat=>{
                     return dat.idlab
                 })


                 const datTo = {
                     "idlabs" : tmpIdlabs,
                     "id_disable_lab" : this.id_disable_lab
                 }

                 this.isFullScreenLoading = true
                 axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                 axios.post(`${getBaseURLforBackEnd()}/api/disable_labnonautomate_arr`,datTo,getConfigAxios())
                     .then((res)=>{
                         vm.$buefy.toast.open({
                             duration: 2000,
                             message: `${res.data.msg}`,
                             position: 'is-bottom',
                             type: 'is-success'
                         })
                         vm.isFullScreenLoading = false
                         vm.$emit('saveChanged')
                     })
                     .catch((err)=>{
                         vm.$buefy.toast.open({
                             duration: 2000,
                             message: `${err.message}`,
                             position: 'is-bottom',
                             type: 'is-danger'
                         })
                         vm.isFullScreenLoading = false
                     })

             },
             saveToDisable(){

                 if(this.id_disable_lab === null){
                     this.hasErrorReasonNull = true
                 }else{

                     this.$buefy.dialog.confirm({
                         title: 'Disable Lab',
                         message: 'Are you sure you want to <b>disable</b>? This action cannot be undone.',
                         confirmText: 'Disable Lab',
                         type: 'is-danger',
                         hasIcon: true,
                         onConfirm: () => this.saveToDisableReal()
                     })
                 }

             },
             isIDLabSelected(_id){
               const tmp =  this.checkedRows.find(dat=>{
                     return dat.idlab === _id
                 })
                 return tmp ? true : false
             }

        },
        watch:{
            id_disable_lab:{
                immediate : true,
                handler : function (val) {
                    if(val){
                        this.hasErrorReasonNull = false
                    }
                }
            },
            data_Selected : {
                immediate : true,
                handler : function (val) {
                    if(val){
                        this.checkedRows=[]
                        this.id_disable_lab = null
                        this.hasErrorReasonNull = false
                        this.loading = false
                    }
                }
            },
        }
    }
</script>

<style scoped>

</style>